var map = {
	"./bfs/app/shared/object-collection/shared/badges/type-badge/type-badge.component": [
		26049,
		"src_themes_bfs_app_shared_object-collection_shared_badges_type-badge_type-badge_component_ts"
	],
	"./custom/app/shared/object-collection/shared/badges/type-badge/type-badge.component": [
		14491,
		"src_themes_custom_app_shared_object-collection_shared_badges_type-badge_type-badge_component_ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 45796;
module.exports = webpackAsyncContext;